var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0c2c239f16b8c3996cb5ad33b9e02747.js').default;export default
        Object.assign({}, scope_0 )
    